// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2dOcI","textLogo":"index-module--textLogo--4ryTt"};